export default __webpack_public_path__ + "static/cognizant_3-8d6681210045cf38e7de07233ea2070b.jpeg";